import { HomePage } from '../components/pages'

export default HomePage
